export default __webpack_public_path__ + "static/media/house-contact.5a8d979e.svg";